import { TeaWeb } from "./web-sdk";
import { TeaJsb } from "./jsb-sdk";
class MixTea {
  _useSdk(type) {
    if (type === "jsb") {
      this._sdk = new TeaJsb();
    }
  }
  init(initOpts) {
    if ("jsb" in initOpts) {
      this._useSdk("jsb");
    }
    this._sdk.init(initOpts);
  }
  start() {
    this._sdk.start();
  }
  collectEvent({ eventName, params }) {
    this._sdk.collectEvent({
      eventName,
      params
    });
  }
  setGlobalEventParams(eventParams) {
    if (!eventParams)
      return;
    this.config({
      evtParams: eventParams
    });
  }
  config(config) {
    this._sdk.config(config);
  }
  call(fnName, ...args) {
    return this._sdk.call(fnName, ...args);
  }
  create(prefix) {
    return this._sdk.create(prefix);
  }
  constructor() {
    this._sdk = new TeaWeb();
  }
}
export {
  MixTea
};

//# sourceMappingURL=mix-sdk.js.map